import { Stack } from '@mui/material';
import { SelectInput, TextInput, useRecordContext } from 'react-admin';

import { leadStatusEditChoices } from '@/root/defaultConfiguration';
import type { Lead } from '@/types';

export const LeadInputs = () => {
    const record = useRecordContext<Lead>();
    return (
        <Stack>
            <TextInput source="name" helperText={false} />
            <TextInput type="email" source="email" helperText={false} />
            <TextInput type="tel" source="phone_number" helperText={false} />
            <TextInput source="requirements" multiline minRows={3} helperText={false} />
            <TextInput source="source_path" sx={{ display: 'none' }} />
            <SelectInput
                source="status"
                choices={leadStatusEditChoices(record?.status)}
                optionText="label"
                optionValue="value"
                helperText={false}
            />
        </Stack>
    );
};
